import React, { useState } from "react";
import { useFormikContext } from "formik";
import { TabPanel, TabView } from "primereact/tabview";
import { Checkbox } from "primereact/checkbox";
import {
  FormDateField,
  FormSelectField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";
import { AttachMoney, Percent } from "@mui/icons-material";
import { Accordion, AccordionTab } from "primereact/accordion";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import SearchItem from "../../../inventory/items/searchItem";
import { DialogActions } from "@material-ui/core";
import SearchItemUom from "../../../inventory/items/searchItemUom";
import DiscountTriggerItems from "./DiscountTriggerItems";
import DiscountFreeItems from "./DiscountFreeItems";
import { Card, Badge } from "react-bootstrap";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { useEffect } from "react";
function DiscountFormContent(props) {
  const { values, setFieldValue } = useFormikContext();
  const [openSearchItem, setOpenSearchItem] = useState(false);
  const [openSearchItemType, setOpenSearchItemType] = useState(false);
  const [tab, setTab] = useState({
    ID: 1,
    title: "Sellable Items",
    icon: "fas fa-boxes",
  });
  const [openSearchUom, setOpenSearchUom] = useState(false);
  const [itemSelected, setItemSelected] = useState({});
  const [indexSelected, setIndexSelected] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const [arrayName, setArrayName] = useState("");
  const [buttonGroupActive, setButtonGroupActive] = useState(0);
  const [tabs, setTabs] = useState([
    {
      title: "Trigger Items",
      component: (
        <DiscountTriggerItems
          setIndexSelected={setIndexSelected}
          setOpenSearchItemType={setOpenSearchItemType}
          setOpenSearchItem={setOpenSearchItem}
          setArrayName={setArrayName}
          setItemSelected={setItemSelected}
          setOpenSearchUom={setOpenSearchUom}
        />
      ),
    },
  ]);
  function changeTabs(discountType = 0, minPurchaseType = 0) {
    const tabsTmp = [];
    if (minPurchaseType === 1) {
      tabsTmp.push({
        title: "Trigger Items",
        component: (
          <DiscountTriggerItems
            setIndexSelected={setIndexSelected}
            setOpenSearchItemType={setOpenSearchItemType}
            setOpenSearchItem={setOpenSearchItem}
            setArrayName={setArrayName}
            setItemSelected={setItemSelected}
            setOpenSearchUom={setOpenSearchUom}
          />
        ),
      });
    }
    if (discountType === 2) {
      tabsTmp.push({
        title: "Free Items",
        component: (
          <DiscountFreeItems
            setIndexSelected={setIndexSelected}
            setOpenSearchItemType={setOpenSearchItemType}
            setOpenSearchItem={setOpenSearchItem}
            setArrayName={setArrayName}
            setItemSelected={setItemSelected}
            setOpenSearchUom={setOpenSearchUom}
          />
        ),
      });
    }
    if (discountType !== 2) {
      setFieldValue("discountFreeItem", []);
    }

    if (minPurchaseType !== 1) {
      setFieldValue("discountTriggerItem", []);
    }
    setTabs(tabsTmp);
  }
  useEffect(() => {
    changeTabs(values.discountType, values.minPurchaseType);
  }, [values.discountType, values.minPurchaseType]);
  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <Card>
            <Card.Header>
              <i className="fas fa-window-maximize"></i>
              <span>
                <strong>Discount Header</strong>
              </span>
              {values.ID > 0 ? (
                <React.Fragment>
                  <Badge
                    className="float-right ml-1"
                    variant={
                      values.discountStatus === 2
                        ? "danger"
                        : values.discountStatus === 1
                        ? "success"
                        : null
                    }
                  >
                    {values.discountStatus !== 0
                      ? "Discount " + values.discountStatusDesc
                      : null}
                  </Badge>
                </React.Fragment>
              ) : null}
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <FormSelectField
                    label="Discount Type"
                    name="discountType"
                    options={[
                      { value: 1, label: "Price Discount" },
                      { value: 2, label: "Buy X get Y" },
                      { value: 3, label: "Free Shipping" },
                    ]}
                    onSelectChange={(value) => {
                      changeTabs(value, values.minPurchaseType);
                    }}
                  />
                  <FormSelectField
                    label="Minimum Purchase Requirement"
                    name="minPurchaseType"
                    options={[
                      { value: 1, label: "Minimum Quantity of Items" },
                      { value: 2, label: "Minimum Purchase Amount" },
                      { value: 3, label: "No Minimum Requirement" },
                    ]}
                    onSelectChange={(value) => {
                      changeTabs(values.discountType, value);
                    }}
                  />
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormTextField
                        label="Discount Code"
                        name="discountCode"
                        upperCase="uppercase"
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormTextField
                        label="Discount Name"
                        name="discountName"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-6">
                      <FormDateField label="Start Date" name="startDate" />
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-6">
                      <FormDateField label="End Date" name="endDate" />
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <FormTextField
                    label="Max Discount Use (0 unlimited)"
                    name="maxDiscountUse"
                  />
                  {values.minPurchaseType === 2 ? (
                    <FormTextField
                      label="Min Purchase Amount"
                      name="minPurchaseAmount"
                      currencyField
                    />
                  ) : null}

                  {values.discountType === 1 ? (
                    <div className="row">
                      <div className="col-10">
                        {values.discountAmountType === 1 ? (
                          <FormTextField
                            label="Discount Percent"
                            name="discountPercent"
                            percentageField
                          />
                        ) : (
                          <FormTextField
                            label="Discount Value"
                            name="discountValue"
                            currencyField
                          />
                        )}
                      </div>
                      <div className="col-2">
                        <div
                          className="btn-group btn-group-sm my-2"
                          role="group"
                        >
                          <BootstrapTooltip title="Input By Amount">
                            <button
                              type="button"
                              className={`btn btn-${
                                buttonGroupActive === 0
                                  ? "success"
                                  : "label-dark"
                              } btn-sm btn-bold`}
                              onClick={() => {
                                setButtonGroupActive(0);
                                setFieldValue(`discountAmountType`, 2);
                              }}
                            >
                              <AttachMoney />
                            </button>
                          </BootstrapTooltip>
                          <BootstrapTooltip title="Input By Percentage">
                            <button
                              type="button"
                              className={`btn btn-${
                                buttonGroupActive === 1
                                  ? "success"
                                  : "label-dark"
                              } btn-sm btn-bold`}
                              onClick={() => {
                                setButtonGroupActive(1);
                                setFieldValue(`discountAmountType`, 1);
                              }}
                            >
                              <Percent />
                            </button>
                          </BootstrapTooltip>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <div className="row mt-2">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <h5>Applied To</h5>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="p-field-checkbox my-2">
                        <Checkbox
                          icon="pi pi-check-circle"
                          inputId="appliedQuot"
                          onChange={(e) => {
                            setFieldValue("appliedQuot", e.checked);
                          }}
                          checked={values.appliedQuot}
                        />
                        <label htmlFor="appliedQuot">
                          <strong>Quotation</strong>
                        </label>
                      </div>
                      <div className="p-field-checkbox my-2">
                        <Checkbox
                          icon="pi pi-check-circle"
                          inputId="appliedSo"
                          onChange={(e) => {
                            setFieldValue("appliedSo", e.checked);
                          }}
                          checked={values.appliedSo}
                        />
                        <label htmlFor="appliedSo">
                          <strong>Sales Order</strong>
                        </label>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="p-field-checkbox my-2">
                        <Checkbox
                          icon="pi pi-check-circle"
                          inputId="appliedDs"
                          onChange={(e) => {
                            setFieldValue("appliedDs", e.checked);
                          }}
                          checked={values.appliedDs}
                        />
                        <label htmlFor="appliedDs">
                          <strong>Direct Sales</strong>
                        </label>
                      </div>
                      <div className="p-field-checkbox my-2">
                        <Checkbox
                          icon="pi pi-check-circle"
                          inputId="appliedOutlet"
                          onChange={(e) => {
                            setFieldValue("appliedOutlet", e.checked);
                          }}
                          checked={values.appliedOutlet}
                        />
                        <label htmlFor="appliedOutlet">
                          <strong>Outlet</strong>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
      {tabs.length ? (
        <div className="accordion">
          <div className="card">
            <Accordion
              className="accordion"
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <AccordionTab
                header={
                  <React.Fragment>
                    <i className="fas fa-sitemap"></i>
                    <span>
                      <strong>Discount Items</strong>
                    </span>
                  </React.Fragment>
                }
              >
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="tabview">
                      <div className="card">
                        <TabView
                          renderActiveOnly={false}
                          className="tabview"
                          scrollable
                        >
                          {tabs.map((tab, index) => (
                            <TabPanel index={index} header={tab.title}>
                              {tab.component}
                            </TabPanel>
                          ))}
                        </TabView>
                      </div>
                    </div>
                  </div>
                </div>
              </AccordionTab>
            </Accordion>
          </div>
        </div>
      ) : null}
      <DialogLayout
        open={openSearchItemType}
        title="Select Item Type"
        onCloseDialog={() => {
          setOpenSearchItemType(false);
        }}
        maxWIdth="sm"
      >
        <div className="row menu-row-modules mt-4">
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="menu-grid-square">
              <Card
                className="card-select-type"
                onClick={() => {
                  setOpenSearchItemType(false);
                  setOpenSearchItem(true);
                  setTab({
                    ID: 1,
                    title: "Sellable Items",
                    icon: "fas fa-boxes",
                  });
                }}
              >
                <Card.Body>
                  <div className="menu-title mb-2">Sellable Items</div>
                  <i className="fas fa-boxes fa-4x"></i>
                </Card.Body>
              </Card>
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="menu-grid-square">
              <Card
                className="card-select-type"
                onClick={() => {
                  setOpenSearchItemType(false);
                  setOpenSearchItem(true);
                  setTab({
                    ID: 2,
                    title: "Services",
                    icon: "fas fa-tools",
                  });
                }}
              >
                <Card.Body>
                  <div className="menu-title mb-2">Services</div>
                  <i className="fas fa-tools fa-4x"></i>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchItemType(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchItem}
        title="Search Item"
        onCloseDialog={() => {
          setOpenSearchItem(false);
          setOpenSearchItemType(true);
        }}
        minHeight={true}
      >
        <SearchItem
          tab={tab}
          selectSellableItems={true}
          selectServiceItems={true}
          selectItemPackages={false}
          selectAssetItems={false}
          selectVariant={true}
          onSelectItem={(item, itemPackage, varCode, valueName) => {
            if (item !== null) {
              const data = [...values[arrayName]];
              if (arrayName === "discountTriggerItem") {
                data.push({
                  itemID: item.ID,
                  itemType: item.itemType,
                  itemTypeName: item.itemTypeName,
                  itemCode: item.itemCode,
                  itemName: item.itemName + " " + valueName,
                  varCode: varCode,
                  requireQty: 0,
                  uomID: item.uomID,
                  uomName: item.itemUom.uomName,
                });
              } else {
                data.push({
                  itemID: item.ID,
                  itemType: item.itemType,
                  itemTypeName: item.itemTypeName,
                  itemCode: item.itemCode,
                  itemName: item.itemName + " " + valueName,
                  varCode: varCode,
                  qty: 0,
                  uomID: item.uomID,
                  uomName: item.itemUom.uomName,
                });
              }
              setFieldValue(`${arrayName}`, data);
              setOpenSearchItem(false);
            }
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchItem(false);
              setOpenSearchItemType(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchUom}
        title="Search Unit of Measurement"
        onCloseDialog={() => {
          setOpenSearchUom(false);
        }}
        maxWIdth="sm"
      >
        {itemSelected.itemID > 0 ? (
          <SearchItemUom
            itemID={itemSelected.itemID}
            onSelectUom={(uom) => {
              setFieldValue(`${arrayName}[${indexSelected}].uomID`, uom.ID);
              setFieldValue(
                `${arrayName}[${indexSelected}].uomName`,
                uom.uomName
              );
              setOpenSearchUom(false);
            }}
          />
        ) : null}
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchUom(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default DiscountFormContent;
